import YSkuImport from './src'

YSkuImport.install = Vue => {
  Vue.component(YSkuImport.name, YSkuImport)
}

export default YSkuImport
